module.exports = __webpack_public_path__ + "static/media/PregnancyProgram.f1a921d2.svg";